import { Injectable } from '@angular/core';
import { CurrentUserService } from 'src/app/core/current-user.service';
import { IPermissionsService } from 'src/app/shared/authorization/permissions.service.interface';

export const maintenancePermissions = {
  routeMaintenanceParameters: 'maintenance-parameters:route',
  showMaintenanceAdminLink: 'maintenance-paramaters:show',
};

@Injectable({
  providedIn: 'root',
})
export class MaintenancePermissionsService implements IPermissionsService {
  constructor(private _currentUser: CurrentUserService) {}

  public hasPermission(operation: string): boolean {
    const user = this._currentUser.value;
    if (user == null) {
      return false;
    }
    switch (operation) {
      case maintenancePermissions.routeMaintenanceParameters:
      case maintenancePermissions.showMaintenanceAdminLink:
        return user.isAviationSupervisor;
      default:
        return false;
    }
  }
}
